import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StudentAttendanceService } from '../student-attendance.service';
import { NgxSpinnerService } from 'ngx-spinner';

export interface AttendanceSummary {
  totalStudents?: number;
  totalPresent?: number;
  totalAbsent?: number;
  totalSick?: number;
  totalOuting?: number;
  totalLeft?: number;
  transferIn?: number;
  transferOut?: number;
}

export interface CampusSummaryDialogData {
  summary: AttendanceSummary | null;
  attendanceDate?: string;
}

@Component({
  selector: 'app-student-attendance-campus',
  templateUrl: './student-attendance-campus.component.html',
  styleUrls: ['./student-attendance-campus.component.scss']
})
export class StudentAttendanceCampusComponent implements OnInit {
  summary: AttendanceSummary | null = null;

  constructor(
    private dialogRef: MatDialogRef<StudentAttendanceCampusComponent>,
    private dataService: StudentAttendanceService,
    @Inject(MAT_DIALOG_DATA) public data: CampusSummaryDialogData,private spinner: NgxSpinnerService
  ) {
    this.summary = this.data?.summary ?? null;
  }

  ngOnInit(): void {
    this.getcampuscount();
  }

  getcampuscount(): void {
    const dateStr = this.data?.attendanceDate ?? '';
    if (!dateStr) {
      return;
    }
    this.spinner.show();
    this.dataService.getstudentcount(dateStr).subscribe({
      next: (res: any) => {
        if (res) {
          this.summary = {
            totalStudents: res.totalStudents ?? 0,
            totalPresent: res.totalPresent ?? 0,
            totalAbsent: res.totalAbsent ?? 0,
            totalSick: res.totalSick ?? 0,
            totalOuting: res.totalOuting ?? 0,
            totalLeft: res.totalLeft ?? 0,
            transferIn: res.totalTransferredIn ?? 0,
            transferOut: res.totalTransferredOut ?? 0
          };
          this.spinner.hide();
        }
      },
      error: (err) => {
        console.error('Campus attendance API Error:', err);
        this.spinner.hide();
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
